import React from 'react'
import Edit from '../crud/edit'
import fields from './fields'
import menuItems from './menuItems'

const EditProgramQuestion = (props) => {
  return (
    <Edit
// @ts-ignore
      title='Edit Program Question'
      fields={fields}
      apiPath={`admin/program_questions/${props.params.programQuestionId}`}
      successRedirectPath='/write-now/program_questions'
      buildMenuItems={menuItems}
    />
  )
}

export default EditProgramQuestion
